/* import __COLOCATED_TEMPLATE__ from './integration-status.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();